import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone } from "lucide-react";
import logoTikratoli from "@/assets/logo-tikratoli.png";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-32 border-t border-white/10">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-start gap-5">
            <img
              src={logoTikratoli}
              alt="Tikratoli Estate crest"
              className="h-20 md:h-24 w-auto drop-shadow-[0_2px_10px_rgba(0,0,0,0.4)]"
              data-testid="footer-logo"
            />
            <div className="font-display text-4xl md:text-5xl leading-[1] text-[#F2E7D0]">
              Tikratoli
              <br />
              Farm Resorts
            </div>
          </div>
          <p className="mt-6 max-w-md text-[#B8A891] text-sm leading-relaxed">
            A working heritage estate in Ranchi, Jharkhand — a 1930's British hunting lodge, a
            mango and lychee orchard, a private Sal forest, and 1942 open-top jeeps that
            still start on the first crank.
          </p>
        </div>

        <div>
          <div className="font-mono-label text-[#D97645] mb-4">Estate</div>
          <ul className="space-y-2 text-sm text-[#F2E7D0]/80">
            <li><Link to="/heritage" className="link-underline">Heritage</Link></li>
            <li><Link to="/accommodation" className="link-underline">Stay</Link></li>
            <li><Link to="/dining" className="link-underline">Dining</Link></li>
            <li><Link to="/orchard" className="link-underline">Orchard & Forest</Link></li>
            <li><Link to="/banquet" className="link-underline">Banquets & Events</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-mono-label text-[#D97645] mb-4">Reach</div>
          <ul className="space-y-2 text-sm text-[#F2E7D0]/80">
            <li><Link to="/booking" className="link-underline">Reserve</Link></li>
            <li><Link to="/manage-booking" className="link-underline">Manage booking</Link></li>
            <li><Link to="/contact" className="link-underline">Enquire</Link></li>
            <li><Link to="/admin/login" className="link-underline text-[#B8A891]">Admin</Link></li>
          </ul>
          <div className="mt-6 font-mono-label text-[#B8A891]">
            Ranchi · Jharkhand<br/>
            India
          </div>
          <div className="mt-6">
            <a href="tel:+917004810637" className="inline-flex items-center gap-2 text-[#F2E7D0] hover:text-[#D97645] transition text-sm">
              <Phone size={14} /> Rahul · +91 70048 10637
            </a>
          </div>
          <div className="mt-4 flex items-center gap-3">
            <a href="https://instagram.com/tikratoli_farm_resorts/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="w-9 h-9 border border-white/20 hover:border-[#D97645] hover:text-[#D97645] flex items-center justify-center text-[#F2E7D0] transition">
              <Instagram size={14} />
            </a>
            <a href="https://facebook.com/TikratoliBanquets" target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="w-9 h-9 border border-white/20 hover:border-[#D97645] hover:text-[#D97645] flex items-center justify-center text-[#F2E7D0] transition">
              <Facebook size={14} />
            </a>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 py-6 border-t border-white/5 flex flex-col md:flex-row justify-between gap-3 font-mono-label text-[#B8A891]">
        <span>© {new Date().getFullYear()} Tikratoli Farm Resorts</span>
        <span>A working farm since the 1930's</span>
      </div>
    </footer>
  );
}
